import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AiOutlineCalendar } from 'react-icons/ai';
import { FaUserCheck, FaSignOutAlt } from 'react-icons/fa';
import { BsCurrencyDollar } from 'react-icons/bs';
import talentLogo3 from '../../assets/talentlogo3-removebg-preview.png';
import { BASE_URL } from '../../config';
import useAuth from '../../hooks/useAuth';
import { resolveBackendUrl } from '../../utils/accountAvatarUrl';
import defaultProfilePic from '../../assets/default_profile_pic.jpeg';

const CustomerSidebar = ({ onLinkClick, fullWidth = true }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  const [profilePicture, setProfilePicture] = useState("");
  const [userName, setUserName] = useState("");
  
  const menuItems = [
    { path: '/availability', label: 'Calendar', icon: <AiOutlineCalendar size={19} /> },
    // { path: '/assignedTask', label: 'Assigned Task', icon: <FaUserCheck size={19} /> },
    // { path: '/earnings', label: 'Earnings', icon: <BsCurrencyDollar size={19} /> }
  ];

  // Fetch profile picture
  useEffect(() => {
    const loadProfile = async () => {
      try {
        const accountId = auth?.accountId || localStorage.getItem("accountId");
        const token = auth?.token || localStorage.getItem("token");
        if (!accountId) return;

        const res = await fetch(`${BASE_URL}/api/my-account/account/me`, {
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          credentials: "include",
        });

        const json = await res.json();
        if (json.success && json.data) {
          const d = json.data;
          setProfilePicture(resolveBackendUrl(d.profile_picture));
          const fn = d.first_name || "";
          const ln = d.last_name || "";
          setUserName(`${fn} ${ln}`.trim() || "Temp Staff");
        }
      } catch (e) {
        console.error("Failed to load profile", e);
      }
    };

    if (auth?.accountId || localStorage.getItem("accountId")) {
      loadProfile();
    }
  }, [auth?.accountId]);


  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("accountId");
    // localStorage.removeItem("isAdmin");
    window.dispatchEvent(new Event('authUpdate'));
    navigate("/login");
  };

  const containerClass = fullWidth ? 'w-full bg-sidebar-bg text-sidebar-text flex flex-col h-screen sticky top-0 overflow-y-auto' : 'w-60 bg-sidebar-bg text-sidebar-text flex flex-col h-screen sticky top-0 overflow-y-auto';

  return (
    <div className={containerClass}>
      <div className="p-6">
        <div className="flex items-center justify-center">
          <img src={talentLogo3} alt="Talent Logo" className="h-12 w-auto" />
        </div>
      </div>

      <nav>
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => onLinkClick && onLinkClick()}
            className={`w-full flex items-center px-4 py-3 mb-1 rounded-lg transition-colors ${
              location.pathname === item.path 
                ? 'bg-sidebar-active text-white' 
                : 'text-sidebar-text-muted hover:bg-sidebar-hover hover:text-sidebar-text'
            }`}
          >
            <span className="text-sm font-medium ml-2 mr-4 text-sidebar-text">{item.icon}</span>
            {item.label}
          </Link>
        ))}
      </nav>

      <div className="p-4 border-t border-sidebar-hover mt-auto">
        <Link to="/myaccount-tempstaff" onClick={() => onLinkClick && onLinkClick()}>
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 rounded-full flex items-center justify-center overflow-hidden border border-gray-300 bg-white">
              <img
                src={profilePicture || defaultProfilePic}
                alt="Profile"
                className="w-full h-full object-cover"
                onError={(e) => {
                  if (e.target.src !== defaultProfilePic) {
                    e.target.src = defaultProfilePic;
                  }
                }}
              />
            </div>
            <div className="flex flex-col">
              <span className="text-sm text-sidebar-text-muted">My Account</span>
              <span className="text-xs text-sidebar-text-muted">{userName || "Temp Staff"}</span>
            </div>
          </div>
        </Link>
        <button
          onClick={handleLogout}
          className="flex items-center px-4 py-2 mt-2 text-sidebar-text-muted hover:bg-sidebar-hover hover:text-sidebar-text rounded-lg transition-colors w-full"
        >
          <FaSignOutAlt className="mr-2 font-medium text-sidebar-text-muted" size={18} />
          <span className="text-sm font-medium">Sign Out</span>
        </button>
      </div>
    </div>
  );
};

export default CustomerSidebar;
